export const PAGE_TITLE = "shooshte";
